import { Store } from 'redux';
import { configureStore, combineRootReducers } from '@tmapy/redux';
import { persistStore } from 'redux-persist';

import { getInitialState } from '@tmapy/map-search';

import { reducers } from './reducer';
import { mapMiddleware } from './mapMiddleware';

export async function configurePersistStore(): Promise<Store> {
  combineRootReducers(reducers);

  const searchInitialState = getInitialState();
  const initialState = {
    mapSearch: searchInitialState,
  };

  const store = configureStore(initialState, [mapMiddleware]);
  await new Promise<void>((resolve) => persistStore(store, null, resolve));

  return store;
}
